/* MEPZITE · shared storefront measurements · 1.3.0 */
(() => {
  'use strict';
  if (window.MPZAfiyaChrome) return;
  let frame = 0, last = -1;
  const header = document.querySelector('.section-header');
  const update = () => {
    frame = 0;
    const rect = header?.getBoundingClientRect();
    const position = header ? getComputedStyle(header).position : '';
    const clearance = rect && /^(sticky|fixed)$/.test(position) ? Math.ceil(Math.max(0, Math.min(rect.height, rect.bottom))) : 0;
    if (clearance !== last) { document.documentElement.style.setProperty('--mpz-header-clearance', `${clearance}px`); last = clearance; }
  };
  const queue = () => { if (!frame) frame = requestAnimationFrame(update); };
  window.addEventListener('resize', queue, { passive: true });
  window.addEventListener('scroll', queue, { passive: true });
  const resize = typeof ResizeObserver !== 'undefined' && header ? new ResizeObserver(queue) : null;
  resize?.observe(header);
  window.MPZAfiyaChrome = { version: '1.3.0', destroy() { cancelAnimationFrame(frame); resize?.disconnect(); window.removeEventListener('resize', queue); window.removeEventListener('scroll', queue); document.documentElement.style.removeProperty('--mpz-header-clearance'); delete window.MPZAfiyaChrome; } };
  update();
})();
